module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-29-min.74f19c94.jpg";